import React from "react";
import { Stepper, Step, StepLabel } from "@mui/material/";
import "./Stepper.css";
StepperComp.defaultProps = {
  steps: [],
  activeStep: 0,
  orientation: "horizontal",
};

// 

export default function StepperComp({ steps, activeStep, orientation, alternativeLabel }) {

  return (
    <div>
      <Stepper activeStep={activeStep} orientation={orientation} alternativeLabel={alternativeLabel}>
        {steps.map((step) =>
          step ? (
            <Step key={step.id}>
              <StepLabel>{step.label}</StepLabel>
            </Step>
          ) : null
        )}
      </Stepper>
    </div>
  );
}
